import { WEB_COMPONENT_NETWORK_V2_APP } from '../webcomponents.constants';
import { NetworkV2AppWebComponent } from './component/NetworkV2AppWebComponent';

window.customElements.define(WEB_COMPONENT_NETWORK_V2_APP, NetworkV2AppWebComponent);

export { NetworkV2AppWebComponent };
